exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span {\n  background: transparent;\n  color: #ff404e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/login/login.component.scss
// module id = ../../../../../src/app/pages/login/login.component.scss
// module chunks = main